import React from 'react';
import Skeleton from 'react-loading-skeleton';
import {
  Row, Col,
} from 'reactstrap';

export const AllergiesInfoSkeleton = () => (
  <>
    <Row className="mb-3">
      <Col xs={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={30}
        />
      </Col>
      <Col xs={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={30}
        />
      </Col>
    </Row>
    <Row className="mb-3">
      <Col xs={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={30}
        />
      </Col>
      <Col xs={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={30}
        />
      </Col>
    </Row>
  </>
);

export const ConsiderationsInfoSkeleton = () => (
  <>
    <Row className="mb-3">
      <Col xs={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={30}
        />
      </Col>
      <Col xs={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={30}
        />
      </Col>
    </Row>
    <Row className="mb-3">
      <Col xs={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={30}
        />
      </Col>
    </Row>
  </>
);

export const SedationsInfoSkeleton = () => (
  <>
    <Row className="mb-3">
      <Col xs={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={30}
        />
      </Col>
      <Col xs={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={30}
        />
      </Col>
    </Row>
    <Row className="mb-3">
      <Col xs={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={30}
        />
      </Col>
    </Row>
  </>
);
